import { type GridApiPro, type GridColDef, type GridRenderCellParams } from "@mui/x-data-grid-pro";
import { type Dispatch, type MutableRefObject, type SetStateAction } from "react";

import ThreeDotMenu from "../../../../global/components/ThreeDotMenu";
import IdpGroupAutocompleteCell from "../IdpGroupAutocompleteCell";
import { ScimWizardRoleNameCell } from "../styled/scim-wizard.styled";

interface ExternalGroupOption {
	externalGroupId: string;
	externalGroupName: string;
	[key: string]: unknown;
}

export interface Step6GroupRow {
	id: string | number;
	name: string;
	idpGroups?: ExternalGroupOption[];
	[key: string]: unknown;
}

type MappedGroups = Record<string, ExternalGroupOption[]>;

export const getStep6GroupColumns = (
	identityProviderName: string,
	idpGroups: ExternalGroupOption[],
	mappedGroups: MappedGroups,
	setMappedGroups: Dispatch<SetStateAction<MappedGroups>>,
	apiRef: MutableRefObject<GridApiPro | null>,
	initializeExternalGroups: () => Promise<void> | void,
	setIdpGroups: Dispatch<SetStateAction<ExternalGroupOption[]>>,
	toggleEditGroupDialog: (group: Step6GroupRow) => void,
	toggleDeleteGroupDialog: (group: Step6GroupRow) => void
): GridColDef<Step6GroupRow>[] => [
	{
		field: "name",
		headerName: "CoApp groups",
		sortable: true,
		flex: 1,
		renderCell: (params: GridRenderCellParams<Step6GroupRow, string>) => (
			<ScimWizardRoleNameCell variant="body2" noWrap={true}>{params.value}</ScimWizardRoleNameCell>
		)
	},
	{
		field: "idpGroups",
		headerName: `${identityProviderName} groups`,
		sortable: false,
		flex: 1,
		renderCell: (params: GridRenderCellParams<Step6GroupRow>) => (
			<IdpGroupAutocompleteCell
				options={idpGroups}
				mapped={mappedGroups}
				setMapped={setMappedGroups}
				resourceName={params.row.name}
				apiRef={apiRef}
				initializeGroupOptions={initializeExternalGroups}
				setExternalGroups={setIdpGroups}
			/>
		)
	},
	{
		field: "actions",
		type: "actions",
		sortable: false,
		flex: .1,
		renderCell: (params: GridRenderCellParams<Step6GroupRow>) => (
			<div>
				<ThreeDotMenu
					options={[
						{
							name: "Edit",
							optionClickHandler: () => {
								toggleEditGroupDialog(params.row);
							},
						},
						{
							name: "Delete",
							optionClickHandler: () => {
								toggleDeleteGroupDialog(params.row);
							},
						},
					]}
				/>
			</div>
		)
	}
];
